import { path, map, pipe } from 'ramda';

import {
  mapUsersToSale,
  mapPaymentStatus,
  collectDescription,
} from '../../../register/summary/selectors';

const getRefundsAndDiscountsFromState = path(['reports', 'refundsAndDiscounts']);

const mapTransactionsToSales = map(transaction => ({
  ...transaction,
  items: [transaction],
}));

// eslint-disable-next-line import/prefer-default-export
export const getRefundsAndTransactions = pipe(
  getRefundsAndDiscountsFromState,
  mapTransactionsToSales,
  mapUsersToSale,
  collectDescription,
  mapPaymentStatus
);
